<template>
  <div v-loading="loading" class="box">
    <vue-office-docx v-if="fileType === 'docx'" :src="srcUrl" style="width: 100%; min-height: 72vh;height:100%"
      @rendered="renderedHandler" @error="errorHandler" />
    <vue-office-excel v-else-if="fileType === 'xlsx' || fileType === 'xls'" :src="srcUrl" :options="options"
      style=" min-height: 72vh;height:100%;width: 100%" @rendered="renderedHandler" @error="errorHandler" />
    <vue-office-pdf v-else-if="fileType === 'pdf'" :src="srcUrl" @rendered="renderedHandler"
      @error="errorHandler"></vue-office-pdf>
    <div v-else-if="
      fileType === 'jpg' || fileType === 'png' || fileType === 'jpeg'
    " class="h-100 w-100 con">
      <img :src="src" />
    </div>
    <div v-else>
      <el-empty description="暂不支持该文件格式" />
    </div>
  </div>
</template>
<script>
import VueOfficeDocx from "@vue-office/docx";
import VueOfficeExcel from "@vue-office/excel";
import VueOfficePdf from "@vue-office/pdf";
import "@vue-office/docx/lib/index.css";
import "@vue-office/excel/lib/index.css";
import { tokenName } from "@/config/net.config"

export default {
  props: {
    fileType: {
      type: String,
      default: () => "",
    },
    src: {
      type: String,
      default: () => "",
    },
    fileName: {
      type: String,
      default: () => "",
    }
  },
  components: {
    VueOfficeDocx,
    VueOfficeExcel,
    VueOfficePdf,
  },
  data() {
    return {
      loading: false,
      options: {
        xls: this.fileType == "xls" ? true : false,
        minColLength: 15, // excel最少渲染多少列，如果想实现xlsx文件内容有几列，就渲染几列，可以将此值设置为0.
        minRowLength: 15, // excel最少渲染多少行，如果想实现根据xlsx实际函数渲染，可以将此值设置为0.
        widthOffset: 10, //如果渲染出来的结果感觉单元格宽度不够，可以在默认渲染的列表宽度上再加 Npx宽
        heightOffset: 10, //在默认渲染的列表高度上再加 Npx高
        beforeTransformData: (workbookData) => {
          return workbookData;
        }, //底层通过exceljs获取excel文件内容，通过该钩子函数，可以对获取的excel文件内容进行修改，比如某个单元格的数据显示不正确，可以在此自行修改每个单元格的value值。
        transformData: (workbookData) => {
          return workbookData;
        }, //将获取到的excel数据进行处理之后且渲染到页面之前，可通过transformData对即将渲染的数据及样式进行修改，此时每个单元格的text值就是即将渲染到页面上的内容
      },
      loadingList: ["docx", "xlsx", "xls", "pdf"],
      srcUrl: "",

    };
  },
  mounted() {
    if (this.loadingList.includes(this.fileType)) {
      setTimeout(() => {
        this.loading = true;
        this.getExcelStream()
      }, 1000);

    }
  },
  methods: {
    renderedHandler() {
      this.loading = false;
    },
    errorHandler(e) {
      this.loading = false;
      this.$emit("error")
    },
    getExcelStream() {
      const formData = new FormData();
      formData.append("type", "4");
      formData.append("key", "4");
      formData.append("parent", "0");
      formData.append("name", this.fileName);
      formData.append("list", [this.src]); // 发送POST请求
      fetch("/api/dms/file/download", {
        method: "POST",
        headers: {
          token: localStorage.getItem(tokenName),
        },
        body: formData,
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
          response.arrayBuffer().then((res) => {
            this.srcUrl = res
          })
        })

    }
  },
};
</script>

<style lang="scss" scoped>
.box {
  width: 100%;
  height: 75vh;
  height: 100%;
  background-color: #fff;
  box-sizing: border-box;
  overflow: auto;
}

.con {
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    max-width: 100%;
    max-height: 100%;
  }
}
</style>
